import React, { useState } from 'react'
import { AddCategory } from './components/AddCategory';
import { GifGrid } from './components/GifGrid';

export const GifExpertApp = () => {

    const [categories, setCategories] = useState(['Goku']);

    //const handleAdd = () => {
        //setCategories([ 'HUNTER', ...categories]);
        //setCategories(cats => [ ...cats, 'HUNTER OTHER']);
    //}

    return (
        <>
            <h2>GifExpertApp</h2>
            <AddCategory setCategories={ setCategories } />
            <hr />
            <ol>
                {
                    categories.map( category => (
                        <GifGrid 
                            category = { category } 
                            key = { category }
                        />
                    ))
                }
            </ol>
        </>
    )
}
